
import { style } from 'typestyle'

/* Styles ======================================================================================= */
import { StyleClass } from '../style-class'

/* Types ======================================================================================== */
type ClassNames = {
  component: string

  /**
   * Base class for selector
   */
  base: string

  /**
   * Themed class for selector
   */
  themed: string

  /**
   * Base class for child container
   */
  childContainerBase: string

  /**
   * Proped class for child container
   */
  childContainerProped: {
    horiz: string
  }

  /**
   * Base class for child
   */
  childBase: string

  /**
   * Proped class for child
   */
  childProped: {
    selected: string
  }

  /**
   * Base class for hover indicator
   */
  hoverIndicatorBase: string

  /**
   * Proped class for hover indicator proped
   */
  hoverIndicatorProped: {
    hovered: string
    shouldCoverOnSelect: string
  }
  /**
   * Base class for hover indicator
   */
  selectIndicatorBase: string
  /**
   * Proped class for hover indicator proped
   */
  selectIndicatorProped: {
    hovered: string
  }
}

type ClassProps = {
  horiz?: boolean
  shouldCoverOnSelect?: boolean
}

const getNames: (props: ClassProps, theme: any) => ClassNames = (props, theme) => {
  const { shouldCoverOnSelect, horiz } = props

  const component = style({
    width: '100%',
  })

  const base = style({
    boxSizing: 'border-box',
    height: '100%',
    position: 'relative',
    userSelect: 'none',
  })

  const themed = style({
    $nest: {
      '> *': {
        position: 'relative',
      },
    },
  })

  const childBase = style({
    position: 'relative',
    cursor: 'pointer',
    transition: theme.transition.slow,
    transitionProperty: 'all',
    height: '100%',
  })

  const childProped = {
    selected: style({
      color: shouldCoverOnSelect && theme.getBaseline('primary').contrast.medium,
      $nest: {
        '&::before': {
          content: '""',
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100%',
          height: shouldCoverOnSelect ? '100%' : 3,
          background: shouldCoverOnSelect
            ? theme.getBaseline('primary').color.medium
            : theme.getBaseline('primary').color.dark,
          transition: theme.transition.medium,
          transitionProperty: 'all',
          zIndex: shouldCoverOnSelect ? -1 : 0,
        },
      },
    }),
  }

  const hoverIndicatorBase = style({
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    height: 3,
    background: theme.getBaseline('primary').color.medium,
    transition: theme.transition.medium,
    transitionProperty: 'all',
    cursor: 'pointer',
    zIndex: 0,
    opacity: 0,
  })

  const hoverIndicatorProped = {
    hovered: style({
      opacity: 1,
    }),
    shouldCoverOnSelect: style({
      background: theme.getBaseline('primary').color.dark,
      zIndex: 1,
    }),
  }

  const selectIndicatorBase = style({
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: theme.getBaseline('primary').color.medium,
    transition: theme.transition.medium,
    transitionProperty: 'all',
    cursor: 'pointer',
    zIndex: 0,
    opacity: 0,
  })

  const selectIndicatorProped = {
    hovered: style({
      opacity: 1,
    }),
  }

  const childContainerBase = style({
    flexDirection: 'row',
    display: 'flex',
    height: '100%',
    $nest: {
      '> *': {
        $nest: {
          '&:hover': {
            // background: theme.getBaseline('background').color.medium,
          },
        },
      },
    },
  })

  const childContainerProped = {
    horiz: style({
      flexDirection: 'column',
      height: 'initial',
      $nest: {
        [`& .${childProped.selected}`]: {
          width: '100%',
          $nest: {
            '&::before': {
              content: '""',
              position: 'absolute',
              bottom: 0,
              left: 'unset',
              right: 0,
              width: shouldCoverOnSelect ? '100%' : 3,
              height: '100%',
              background: shouldCoverOnSelect
                ? theme.getBaseline('primary').color.medium
                : theme.getBaseline('primary').color.dark,
              transition: theme.transition.medium,
              transitionProperty: 'all',
              zIndex: shouldCoverOnSelect ? -1 : 0,
            },
          },
        },
      },
    }),
  }

  return {
    component,
    base,
    themed,
    childContainerBase,
    childContainerProped,
    childBase,
    childProped,
    hoverIndicatorBase,
    hoverIndicatorProped,
    selectIndicatorBase,
    selectIndicatorProped,
  }
}

/* Export ======================================================================================= */
export const selectorClass = new StyleClass<ClassNames, ClassProps>(getNames)
